module.exports = __webpack_public_path__ + "img/易门县妇幼保健院.9ef039e5.png";